import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';
import { baseUrlParser } from '../lib';

export const getServerStatusWithResponseTime = async (
    url: string,
    token: string
): Promise<AxiosResponse> => {
    const headers = getDefaultHeaders(token);
    const startTime = Date.now();
    const response = await axiosInstance()
        .get(url, withHeaders(headers))
        .then((res) => {
            const endTime = Date.now();
            const responseTime = endTime - startTime;
            return {
                ...res,
                data: {
                    ...res.data,
                    responseTime,
                },
            };
        });
    return response;
};

export const useServerStatus = (): UseQueryResult<
    AxiosResponse<any>,
    unknown
> => {
    const { getToken } = useAuth();
    const baseUrl: string = baseUrlParser(process.env.REACT_APP_BASE_API_URL);
    return useQuery('server-status', async () =>
        getServerStatusWithResponseTime(
            `${baseUrl}/management/health`,
            getToken()
        )
    );
};
